import z from "zod";
import { validateResponse } from "../validation";
import ky from "ky";
import { Locale } from "app-settings/localesAndCurrencies";
import { generateXRequestId } from "../clients";

export const CORAL_URL = import.meta.env.VITE_CORAL_URL;

export type ReferralSource = "webapp:rejected-path" | "webapp:referral-step" | "webapp:fellow-path";

const fetchCampaignResponseSchema = z.object({
  id: z.number(),
  commission_value: z.string(),
});

const fetchShareLinkResponseSchema = z.object({
  share_url: z.string(),
});

export async function fetchCampaign() {
  const data = await ky
    .get("api/campaigns/webapp", {
      prefixUrl: CORAL_URL,
      headers: {
        "X-Caller": "webapp-funnel",
      },
      hooks: {
        beforeRequest: [
          (request) => {
            request.headers.set("X-Request-ID", generateXRequestId());
          },
        ],
      },
    })
    .json();

  return validateResponse({
    data,
    schema: fetchCampaignResponseSchema,
    tag: "Coral API response",
  });
}

export async function fetchShareLink(
  language: Locale,
  email: string,
  source: ReferralSource,
  coralCampaignId: number,
) {
  const data = await ky
    .post("api/users", {
      json: {
        campaign_id: coralCampaignId,
        email,
        language,
        source,
      },
      prefixUrl: CORAL_URL,
    })
    .json();

  return validateResponse({
    data,
    schema: fetchShareLinkResponseSchema,
    tag: "Coral API response",
  })?.share_url;
}
